export default __webpack_public_path__ + "static/media/icon_geo_chart.4a64304a.svg";